export enum EAbTestingFeature {
  ReduceFriction = 'reduceFriction',
  MonitorProgress = 'monitorProgress',
}

export enum EAbTestingGroup {
  Unaltered = 'unaltered',
  ReduceFriction = 'signupv2_reduceFriction',
  MonitorProgress = 'signupv2_monitorProgress',
  ReduceFrictionAndMonitorProgress = 'signupv2_reduceFrictionAndMonitorProgress',
}

export type AbTestingGroupFeatureMap = {
  [group in EAbTestingGroup]: EAbTestingFeature[];
};
